// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
let QuestionOptionView
export default QuestionOptionView = (function () {
  QuestionOptionView = class QuestionOptionView extends (
    require("lib/static-shim").default(require("lib/core/item-view").default)
  ) {
    static initClass() {
      this.prototype.template = require("./templates/question-option.html")
      this.prototype.tagName = "li"
      this.prototype.className = "question-option"

      this.prototype.triggers = {
        "click .delete": "delete:prompt",
        "click .delete-cancel": "delete:cancel",
        "click .delete-option": "delete:option",
        "click a.correct": "mark:correct"
      }

      this.prototype.ui = { deletePrompt: ".delete-prompt" }
    }

    onRender() {
      return this.$el
        .toggleClass("new", this.model.isNew())
        .toggleClass("correct", this.model.get("is_correct_answer"))
        .attr("cid", this.cid)
        .attr("data-id", this.model.id)
        .attr("data-order", this.model.get("order"))
    }

    onDeletePrompt() {
      return this.ui.deletePrompt.show()
    }

    onDeleteCancel() {
      return this.ui.deletePrompt.hide()
    }

    onDeleteOption() {
      this.destroy()
      return this.model.question.trigger("options:changed")
    }

    onMarkCorrect() {
      this.$el.siblings().removeClass("correct")
      this.$el.toggleClass("correct")
      return this.model.question.trigger("options:changed")
    }
  }
  QuestionOptionView.initClass()
  return QuestionOptionView
})()
